import styled, { css } from 'styled-components';

import { BREAKPOINTS } from '@/constants/breakpoints';

export const TabsWrapper = styled.div<{ $isSimplified: boolean }>`
  display: flex;
  column-gap: 25px;

  ${({ $isSimplified }) =>
    !$isSimplified &&
    css`
      padding: 5px;
      border-radius: 14px;
      background-color: var(--bg-card);
      column-gap: 0px;
    `}
`;

export const Tab = styled.button<{
  $isSelected: boolean;
  $isSimplified: boolean;
}>`
  all: unset;
  cursor: pointer;

  & > * {
    color: ${({ $isSelected }) =>
      $isSelected
        ? 'var(--textAndLabels-main)'
        : 'var(--textAndLabels-tertiary)'};
    transition: color 0.3s linear;
  }

  transition: all 0.3s ease;

  ${({ $isSimplified, $isSelected }) =>
    !$isSimplified &&
    css`
      flex: 1;
      text-align: center;
      padding: 5px 10px;
      border-radius: 14px;
      background-color: ${$isSelected ? 'var(--bg-main)' : 'transparent'};
    `}

  @media (max-width: ${BREAKPOINTS.tablet}) {
    position: relative;

    ${({ $isSimplified, $isSelected }) =>
      $isSimplified &&
      css`
        padding-block: 20px;
        &::after {
          position: absolute;
          bottom: 0;
          left: 0;
          content: ' ';
          height: 1px;
          width: 100%;
          background-color: ${$isSelected
            ? 'var(--textAndLabels-main)'
            : 'transparent'};
          z-index: 2;
        }
      `}
  }
`;
